import { render } from "./P062.vue?vue&type=template&id=47225d08&scoped=true"
import script from "./P062.vue?vue&type=script&lang=js"
export * from "./P062.vue?vue&type=script&lang=js"

import "./P062.vue?vue&type=style&index=0&id=47225d08&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47225d08"]])

export default __exports__